export default __webpack_public_path__ + "static/media/animal-36.87183ca8.svg";